import React from 'react'

import { Box, Button, Divider, Paper, Typography } from '@material-ui/core'

import * as service from 'service'
import useFetch from 'hooks/useFetch'

import { Permitted } from 'components/Permissions'
import TaxesTable from './components/TaxesTable'
import TaxTypesTable from './components/TaxTypesTable'
import DialogTax from './components/DialogTax'

const TaxesMain = () => {
  const { response: responseTax, refresh: refreshTax } = useFetch(
    service.recurrence.taxes.get,
    {},
  )
  const { response: responseTaxTypes, refresh: refreshTaxTypes } = useFetch(
    service.recurrence.taxTypes.get,
  )
  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Box mb={4}>
        <Paper>
          <Box
            p={2}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h4">Impostos da conta</Typography>
            <Permitted tag="create_tax">
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClickOpen}
                >
                  Novo
                </Button>
              </Box>
            </Permitted>
          </Box>
          <Divider />
          <TaxesTable
            data={responseTax && responseTax.data && responseTax.data.taxes}
            perPage={
              responseTax && responseTax.meta && responseTax.meta.perPage
            }
            onEvent={refreshTax}
          />
        </Paper>
      </Box>
      <Paper>
        <Box
          p={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h4">Tipos de imposto</Typography>
        </Box>
        <Divider />
        <TaxTypesTable
          data={
            responseTaxTypes &&
            responseTaxTypes.data &&
            responseTaxTypes.data.taxTypes
          }
          onEvent={refreshTaxTypes}
        />
      </Paper>

      <DialogTax open={open} handleClose={handleClose} onAction={refreshTax} />
    </>
  )
}

export default TaxesMain
